import React from 'react'
import { AutoComplete, Space } from 'antd'
import styles from '../../index.module.less'
import { LayoutEnum } from '../../enum'

const Index = (props: any) => {
  const { field, onChange, value } = props
  const {
    width,
    label,
    placeholder = '请输入或选择',
    layout,
    options,
    allowClear,
    optionFilterProp = 'label',
    selectConfig,
  } = field

  const triggerChange = (v: any) => {
    onChange?.(v)
  }

  const handleChange = (v: any) => {
    triggerChange(v)
  }

  const handleSelect = (v: any) => {
    triggerChange(v)
  }

  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          {label && <div className={styles.addon}>{label}</div>}
          <AutoComplete
            value={value}
            style={{ width }}
            placeholder={placeholder || `请输入或选择${label || ''}`}
            options={options}
            allowClear={allowClear}
            onChange={handleChange}
            onSelect={handleSelect}
            filterOption={(inputValue, option) => {
              const text = (option?.label ?? option?.value ?? '') as string
              return text.toLowerCase().includes((inputValue || '').toLowerCase())
            }}
            {...selectConfig}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          {label && <div className={styles.addon}>{label}</div>}
          <AutoComplete
            value={value}
            style={{ width }}
            placeholder={placeholder || `请输入或选择${label || ''}`}
            options={options}
            allowClear={allowClear}
            onChange={handleChange}
            onSelect={handleSelect}
            filterOption={(inputValue, option) => {
              const text = (option?.label ?? option?.value ?? '') as string
              return text.toLowerCase().includes((inputValue || '').toLowerCase())
            }}
            {...selectConfig}
          />
        </div>
      )}
    </div>
  )
}

export default Index


